import { Measure } from './gtaLogger'

let performanceInstance

export interface PerformanceData {
  measureName: string
  startMark: string
  details?: object
}

export interface PerformanceDataStartEnd extends PerformanceData {
  endMark: string
}

export type PerformanceMeasure = Measure

export class GTAPerformance {
  constructor() {
    if (performanceInstance) {
      throw new Error('New instance of GTA Performance cannot be created')
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    performanceInstance = this
  }

  private sendToLogger(measure: PerformanceMeasure) {
    if (window.goToAdminLogger) {
      window.goToAdminLogger.logMeasure(measure)
    } else {
      console.log(measure)
    }
  }

  /*
   * Take measure as soon as the function is called
   * The measure will start at the given start mark, end mark will be the time when this function is called
   * Send the measure results to splunk if logger available on windows object
   * Delete start mark
   * Delete measure after send it to splunk
   */
  createAndLogMeasureFromStartMark = (performanceData: PerformanceData) => {
    try {
      if (performance.getEntriesByName(performanceData.startMark).length) {
        const measure = performance.measure(performanceData.measureName, performanceData.startMark)
        this.sendToLogger({
          measureName: performanceData.measureName,
          duration: measure.duration,
          details: performanceData.details,
        })
        performance.clearMarks(performanceData.startMark)
        performance.clearMeasures(performanceData.measureName)
      } else {
        console.info(`NOT START MARK ${performanceData.startMark} FOR MEASURE ${performanceData.measureName}`)
      }
    } catch (e) {
      console.error(`CANNOT LOG MEASURE: ${performanceData.measureName}`, e)
    }
  }

  /*
   * Take measure given a start and end mark
   * Send the measure results to splunk if logger available on windows object
   * Delete start and end mark
   * Delete measure after send it to splunk
   */
  createAndLogMeasure = (performanceData: PerformanceDataStartEnd) => {
    try {
      if (
        performance.getEntriesByName(performanceData.startMark).length &&
        performance.getEntriesByName(performanceData.endMark).length
      ) {
        const measure = performance.measure(
          performanceData.measureName,
          performanceData.startMark,
          performanceData.endMark,
        )
        this.sendToLogger({
          measureName: performanceData.measureName,
          duration: measure.duration,
          details: performanceData.details,
        })
        performance.clearMarks(performanceData.startMark)
        performance.clearMarks(performanceData.endMark)
        performance.clearMeasures(performanceData.measureName)
      } else {
        console.info(
          `MISSING MARK ${performanceData.startMark} OR ${performanceData.endMark} FOR MEASURE ${performanceData.measureName}`,
        )
      }
    } catch (e) {
      console.error(`CANNOT LOG MEASURE: ${performanceData.measureName}`, e)
    }
  }
}

const gtaPerformanceInstance = Object.freeze(new GTAPerformance())

export default gtaPerformanceInstance
